export function de() {
  return {
    'form': {
      'from': 'Von',
      'to': 'Zu',
      'username': 'Nutzername',
      'password': 'Passwort',
      'type': 'Art',
      'status': 'Status',
      'transactionPassword': 'Transaktionspasswort',
      'confirmUsername': 'Benutzername bestätigen',
      'confirmPassword': 'Passwort bestätigen',
      'confirmTransactionPassword': 'Transaktionspasswort bestätigen',
      'paymentOption': 'Zahlungsoption',
      'fromProduct': 'Von Produkt',
      'email': 'E-Mail',
      'website': 'Webseite',
      'promotion': 'Promotion',
      'advertisement': 'Werbeanzeige',
      'language': 'Sprache',
      'size': 'Größe',
      'campaign': 'Name der Kampagne',
      'referralCode': 'Referral Code',
      'newPassword': 'Neues Passwort',
      'iban': 'Kontonummer/IBAN',
      'accountName': 'Name des Kontoinhabers / Firmenname',
      'birthDate': 'Geburtstag',
      'citizenship': 'Staatsangehörigkeit',
      'address': 'Address',
      'swift': 'Bankleitzahl (BIC) / SWIFT',
      'bankName': 'Name der Bank',
      'bankAddress': 'Adresse der Bank',
      'isDefault': 'Als Standard benutzen',
    },
    'titles': {
      'bankAccount': 'Bankkonto',
      'dashboard': 'Dashboard',
      'account': 'Mein Konto',
      'profile': 'Mein Profil',
      'transaction': 'Transaktionen',
      'transactionHistory': 'Transaktionsverlauf',
      'overview': 'Übersicht',
      'deposit': 'Einzahlung',
      'withdrawal': 'Auszahlung',
      'transfer': 'Überweisung',
      'productWallet': 'Überweisung (von/zu Produkt)',
      'p2pTransfer': 'Überweisung (Peer to Peer)',
      'skypeBetting': 'Skype Betting',
      'outstandingBets': 'Offene Wetten',
      'betHistory': 'Wettverlauf',
      'betOverview': 'Wettübersicht',
      'affiliate': 'Affiliate',
      'affiliateDashboard': 'Affiliate Dashboard',
      'affiliateTools': 'Affiliate Tools',
      'supportTickets': 'Support Tickets',
      'settings': 'Einstellungen',
      'mobileSite': 'AMS Mobile Webseite',
      'Valid Turnover/Commissions': 'Gültiger Umsatz/Kommission',
      'products': 'Produkte',
      'size': 'Größe',
      'campaign': 'Name der Kampagne',
      'referralCode': 'Referral Code',
      'website': 'Webseite',
      'tickets': 'Support Tickets',
    },
    'tables': {
      'product': 'Produkt',
      'memberId': 'Member ID',
      'totalTurnover': 'Gesamtumsatz',
      'totalWinLoss': 'Gesamt Profit/Verlust der Kunden',
      'totalCommission': 'Affiliate Kommission',
      'date': 'Datum',
      'transactionNumber': 'Transaktionsnummer',
      'type': 'Art',
      'language': 'Sprache',
      'currency': 'Währung',
      'paymentOption': 'Zahlungsoption',
      'amount': 'Betrag',
      'status': 'Status',
      'Total Commission': 'Gesamte Kommission',
      'subject': 'Betreff',
      'description': 'Beschreibung',
      'username': 'Nutzername',
      'balance': 'Kontostand',
      'dateLastUpdated': 'Zuletzt aktualisiert am'
    },
    'Reset password': 'Passwort zurücksetzen',
    'Activate Later': 'Später aktivieren',
    "You're on your way to earning a lifetime commission. Just follow 4 easy steps.": "Du bist auf dem Weg eine lebenslange Kommission zu verdienen, folge einfach diesen 4 einfachen Schritten",
    'I confirm that I have read and accepted': 'Ich bestätige, dass ich dies gelesen und akzeptiert habe',
    'Asianconnect Affiliates Terms and Conditions': 'Asianconnect Affilliate Geschäftsbedingungen',
    'Get Started': 'Lege los',
    'Banners and Referral Codes': 'Banners and Referral Codes',
    'Learn more': 'Erfahre mehr',
    'Archive': 'Archiv',
    'generateBannerNote': 'Fülle das Formular mit deinen Kampagnendetails aus und wir werden dir einen eigenen Referral Code und einen herunterladbaren Banner erstellen.',
    'Setup your username and password now': 'Erstelle jetzt deinen Benutzernamen und dein Passwort',
    'Welcome to AC Affiliates!': 'Herzlich Willkommen zu AC Affilliates!!',
    'Please enter your Campaign Name': 'Bitte gebe den Namen deiner Kampagne ein',
    'Please enter your Referral Code': 'Bitte gebe deinen Referral Code ein',
    'Get code': 'Code abrufen',
    'Reset': 'Zurücksetzen',
    'Generate': 'Generieren',
    'referralCodeNote': 'Du kannst deinen existierenden Referral Code benutzen oder einen neuen erstellen. Sonder und Leerzeichen sind nicht erlaubt.',
    'Special characters and spaces are not allowed.': 'Sonder und Leerzeichen sind nicht erlaubt.',
    'See Preview': 'Siehe Vorschau',
    'Preview': 'Vorschau',
    'Please enter your website URL': 'Bitte gebe die URL deiner Webseite ein',
    'Please contact Customer Support.': 'Bitte kontaktiere den Kundensupport.',
    'Change email': 'E-Mail ändern',
    'Transfer from': 'Überweisung von',
    'Transfer to': 'Überweisung zu',
    'Product': 'Produkt',
    'Please Select': 'Bitte auswählen',
    'Commission Period': 'Kommission Zeitraum',
    'Original Payout Date': 'Originaler Auszahlungstag',
    'to': 'zu',
    'Reason': 'Grund',
    'commission': 'kommission',
    'Search': 'Suche',
    'Reset Filter': 'Filter zurücksetzen',
    'All Status': 'Alle Statuse',
    'Product Username': 'Produkt Benutzername',
    'All Payment Options': 'Alle Zahlungsoptionen',
    'All types': 'Alle Arten',
    'Sign In': 'Anmelden',
    'Sign in to start your session': 'Anmelden um die Session zu starten',
    'Please wait, Logging in...': 'Bitte warten, Anmeldung erfolgt…',
    'signOut': 'Abmelden',
    'memberSince': 'Kunde seit',
    'Note:': 'Anmerkung:',
    'Note': 'Anmerkung',
    'makeDeposit': 'Tätige eine Einzahlung um dein Guthaben zu erhöhen',
    'welcome': 'Welcome to Asianconnect Member Site!',
    'setup': 'Erstelle jetzt deinen Benutzernamen und dein Passwort',
    'to activate your account.': 'um dein Konto zu aktivieren.',
    'setupNote': 'Anmerkung: Dein temporärer Benutzername und Passwort wurden an deine E-Mail Adresse gesendet.',
    'Proceed': 'Fortfahren',
    'Deposit Now': 'Jetzt einzahlen',
    'Available Balance': 'Verfügbares Guthaben',
    'Unallocated Balance': 'Nicht zugewiesenes Guthaben',
    'Account Status': 'Kontostatus',
    'Quick Links': 'Quick Links',
    'BETA': 'BETA',
    'Verified': 'Verifiziert',
    'Not Verified': 'Nicht verifiziert',
    'Filter': 'Filter zurücksetzen',
    'Request Transfer': 'Überweisung anfordern',
    'loadingPageContent': 'Lade Seiteninhalt, bitte warten…',
    'Date Covered:': 'Erfassungsdatum',
    'Total Turnover:': 'Gesamtumsatz:',
    'Total Affiliate Commission:': 'Gesamte Affilliate Kommission:',
    'Total Customer W/L:': 'Gesamt Profit/Verlust der Kunden:',
    'exportCsv': 'Als CSV exportieren',
    'noProduct': 'Kein Produkt',
    'somethingWentWrong': 'Es gab einen Fehler. Bitte überprüfe deine Angaben.',
    'activated': 'Du hast dein Konto erfolgreich aktiviert.',
    'Account Activation': 'Kontoaktivierung',
    'activateAccountNote': 'Um dein Konto zu aktivieren fülle das unten stehende Formular aus.',
    'usernameValidation': 'Darf nur Buchstaben, Nummern und Unterstrich enthalten.',
    'passwordValidation': 'Mindestens 8 Zeichen, mit mindestens 2 Buchstaben, 2 Zahlen und 2 Symbolen.',
    'transactionPasswordValidation': 'Muss alphanumerisch mindestens 6 Zeichen und einen Großbuchstaben enthalten.',
    'Re-enter username': 'Benutzernamen erneut eingeben',
    'Re-enter password': 'Passwort erneut eingeben',
    'Re-enter transaction password': 'Transaktionspasswort erneut eingeben',
    'Activate account': 'Konto aktivieren',
    'Clear All': 'Alles löschen',
    'skrillContent': 'Bitte melde dich bei Skrill an und überweise den Zahlungsbetrag an ',
    'netellerContent': 'Bitte melde dich bei Neteller an und überweise den Zahlungsbetrag an ',
    'verifyDeposit': 'Wir verifizieren nun die Einzahlung. Sobald wir diese erhalten haben wird die Einzahlung in deinem Konto angezeigt.',
    'netellerTransferNote': 'Please login to your NETELLER account and transfer the requested funds to ',
    'netellerTransferNote2': 'mit folgendem Transaktionscode',
    'you will see the additional funds reflected in your account.': 'wirst du das hinzugefügte Guthaben in deinem Konto einsehen können',
    'CONTINUE': 'Fortfahren',
    'cantProcessRequest': "Entschuldigung, wir sind aktuell nicht in der Lage die Anfrage zu bearbeiten",
    'Sorry': 'Entschuldigung',
    'Thank you': 'Vielen Dank',
    'OK': 'OK',
    'For making a deposit': 'Für die Einzahlung',
    'We are now verifying your deposit. Once we have received your deposit,': 'We are now verifying your deposit. Once we have received your deposit,',
    'bankNotice': 'Banküberweisung ist aktuell nicht verfügbar. Bei Anfragen bitte den Kundendienst kontaktieren. Vielen Dank.',
    'bankRestricted': 'Banküberweisung ist in deinem Land nicht verfügbar. Bitte nutze andere Zahlungsoptionen.',
    'processingTime': 'Bearbeitungszeit',
    'fee': 'Gebühr',
    'minimumDeposit': 'Mindesteinzahlungsbetrag',
    'maximumDeposit': 'Maximaleinzahlungsbetrag',
    'chooseProductDeposit': 'Wähle dein bevorzugtes Produkt (Bookie) aus und gebe den gewünschten Einzahlungsbetrag ein.',
    'Product Name': 'Produktname',
    'Amount': 'Betrag',
    'fileValidation': 'Nur jpg jpeg und png Dateien mit einer maximalen Größe von 2 MB erlaubt.',
    'Transaction Summary': 'Transaktionsübersicht',
    'Total amount to be deposited in your account': 'Betrag der auf das Konto eingezahlt werden soll',
    'Total amount to be sent in your account': 'Betrag der auf dein Konto gesendet werden soll',
    'You have submitted the BTC deposit request form.': 'Du hast das BTC Einzahlungsformular abgeschickt.',
    'Please send the BTC amount to the BTC address below. This address is unique to your account.': 'Bitte sende den BTC Betrag zu der unten stehenden BTC Adresse. Diese Adresse ist nur für dein Kundenkonto erstellt worden.',
    'Tap or Scan to pay': 'Antippen oder scannen um zu zahlen',
    'Show QR': 'Zeige QR Code',
    'Total BTC to be sent': 'Gesamt BTC Betrag der gesendet wird',
    'Recipient BTC Address': 'Empfänger BTC Adresse',
    'Please send total BTC to the recipient address.': 'Bitte sende den gesamten BTC Betrag an die Empfängeradresse.',
    'Copy': 'Kopieren',
    'Rate Used per BTC': 'Wechselkurs pro BTC',
    'Please send bitcoin in': 'Bitte sende Bitcoin in',
    'minutes.': 'minuten.',
    'This page will automatically refresh when Bitcoin has been sent.': 'Diese Seite aktualisiert sich automatisch wenn Bitcoin versandt wurde.',
    'Thank you for sending the requested amount!': 'Danke, dass du das angefragten Betrag gesendet hast!',
    'We are now waiting for your Bitcoin confirmations.': 'Wir warten nun auf die Bitcoin Bestätigungen',
    'confirmation(s) received': 'bestätigungen eingegangen',
    'Status': 'Status',
    'Thank you for making a deposit!': 'Vielen Dank für die Einzahlung!',
    'We are now verifying your deposit. Once we have received your deposit, you will see the additional funds reflected in your account.': 'We are now verifying your deposit. Once we have received your deposit, you will see the additional funds reflected in your account.',
    'We are now waiting to receive your bitcoin. The page will automatically update when the bitcoin has been received.': 'Wir warten nun auf den Erhalt deiner Bitcoin. Diese Seite aktualisiert sich automatisch sobald die Bitcoin empfangen wurden.',
    'Requested: waiting to receive bitcoin': 'Angefordert: Warten auf den Erhalt der Bitcoin',
    'Note: Please contact Support if you made a request by mistake and would like to request again': 'Anmerkung: Bitte kontaktiere den Kundendienst falls du eine Anfrage irrtürmlich aufgegeben hast und eine neue stellen möchtest',
    'bitcoinDeclined': "Entschuldige, deine Anfrage wurde abgelehnt. Wahrscheinlich weil wir die Bitcoin nicht erhalten haben. Falls ein Fehler vorliegen sollte kontaktiere den Kundendienst.",
    'Close': 'Schließen',
    'Exchange Rate': 'Wechselkurs',
    'Note: Deposit rate is updated real-time and rate will be locked upon submission of your request.': 'Anmerkung: Der Einzahlungskurs wird in Echtzeit aktualisiert und der Wechselkurs beim absenden der Einzahlungsanfrage gespeichert.',
    'Total BTC amount to send:': 'Gesamt BTC Betrag der gesendet wird:',
    'Total EUR amount to receive:': 'Gesamt EUR Betrag der empfangen wird:',
    'Transaction Status': 'Transaktionsstatus',
    'Requested': 'Angefragt',
    'Pending Confirmation': 'Ausstehende Bestätigungen',
    'Confirmed': 'Bestätigt',
    'Declined': 'Abgelehnt',
    'Voided': 'Ungültig',
    'Account ID': 'Account ID',
    'Amount to deposit': 'Einzahlungsbetrag',
    'Total amount to deposit': 'Gesamtbetrag der eingezahlt wird',
    'Free': 'Kostenlos',
    'Add product': 'Produkt hinzufügen',
    'Make new request': 'Neue Anfrage stellen',
    'we will send you the username and password of your newly registered account.': 'wir werden dir den Nutzernamen und das Passwort deines neu erstellten Kontos zusenden.',
    'Total amount to be deposited on account': 'Gesamtbetrag der auf das Konto eingezahlt wird',
    'Total amount to be deducted from account': 'Gesamtbetrag der vom Konto abgebucht wird',
    'Total amount to be sent': 'Gesamtbetrag der gesendet wird',
    'Total amount to be received': 'Gesamtbetrag der erhalten wird',
    'Enter product username': 'Gebe Nutzernamen des Produkts ein',
    'Total amount to send': 'Gesamtbetrag der versendet werden muss',
    'Request is successfully created!': 'Anfrage erfolgreich erstellt!',
    'Please wait for customer service confirmation. You can view transaction status in Transactions overview.': 'Bitte warten sie auf die Bestätigung des Kundendienstes. Sie können den Transaktionsstatus in der Transaktionsübersicht einsehen.',
    'Unable to Transfer': 'Transfer fehlgeschlagen',
    'Please contact our customer service team to have your account verified. Thank you.': 'Bitte kontaktiere den Kundendienst um dein Konto zu verifizieren. Vielen Dank.',
    'No product(s) available for selection.': 'Keine Produkte zur Auswahl verfügbar.',
    'Opps, amount is not enough!': 'Opps Betrag ist nicht ausreichend!',
    'Minimum amount that can be withdrawn is 100 EUR/GBP.': 'Der Mindestauszahlungsbetrag liegt bei 100 EUR/GBP',
    'Do you want ': 'Möchtest du dass ',
    'to be your default bank for withdrawal?': 'deine Standardbank für Auszahlungen ist?',
    'You have selected Bankwire as your preferred payment gateway. If you would like to choose other payment gateways instead, please click on the next tabs.': 'Du hast Überweisung als dein bevorzugtes Zahlungsmittel ausgewählt. Falls du ein anderes Zahlungsmittel auswählen möchtest klicke auf die nächsten Tabs.',
    'Minimum Withdrawal Amount': 'Mindestauszahlungsbetrag',
    'Maximum Withdrawal Amount': 'Maximalauszahlungsbetrag',
    'Bank Account': 'Bankkonto',
    'Link new bank account': 'Verlinke neues Bankkonto',
    'transactionPasswordHint': 'Hinweis: Falls dein Benutzerkonto schon vor März 2017 existierte und du noch kein Transaktionspasswort festgelegt hast musst du die Sicherheitsfrage beantworten: Was ist dein Traumberuf?',
    'Beneficiary name': 'Name des Zahlungsempfängers',
    'Beneficiary address': 'Adresse des Zahlungsempfängers',
    'IBAN': 'IBAN',
    'Bank name': 'Name der Bank',
    'Bank address': 'Adresse der Bank',
    'SWIFT': 'SWIFT',
    'Total amount to be deducted from your account': 'Gesamtbetrag der vom Konto abgebucht wird',
    'Total amount to be received in your account': 'Gesamtbetrag der in deinem Konto empfangen wird',
    'Confirmation Message': 'Bestätigungsnachricht',
    'Yes': 'Ja',
    'No': 'Nein',
    'confirmations': 'bestätigungen eingegangen',
    'Please select product(s) where you want to withdraw, and input the amount in': 'Bitte wähle die Produkte von denen du eine Auszahlung beantragen möchtest und gebe den Betrag ein',
    'or BTC': 'oder BTC',
    'Total BTC': 'Gesamt BTC',
    'SEND TO': 'SENDE AN',
    'Please make sure that your Bitcoin address is correct. We will send your BTC to this address.': 'Bitte vergewissere dich dass deine Bitcoin Adresse korrekt ist. Wir werden deine BTC an diese Adresse senden.',
    'Total BTC amount to receive': 'Gesamt BTC Betrag der empfangen wird',
    'Total': 'Gesamt',
    'amount to be deducted': 'betrag der abgebucht wird',
    'Amount to deduct': 'betrag zum abbuchen',
    'Total amount to receive': 'gesamtbetrag der empfangen wird',
    'Opps, we need to know where to wire your funds.': 'Opps wir müssen wissen wohin dein Guthaben überwiesen werden soll.',
    'Please fill in the required bank details. Thank you!': 'Bitte fülle die angeforderten Bankdetails aus. Vielen Dank!',
    'Unable to withdraw': 'Auszahlung nicht möglich',
    'Invalid Action!': 'Ungültige Aktion!',
    'A product where the fee should be charged is required.': 'Ein Produkt wovon die Gebühr abebucht werden soll wird benötigt',
    'Reset link was sent to your email.': 'Zurücksetzen Link wurde an deine E-Mail gesendet.',
    'Success!': 'Erfolgreich!',
    'Send reset password link': 'Sende Passwort Zurücksetzen Link',
    "Enter the email you use for Asianconnect88, and we'll help you create a new password.": "Gebe die E-Mail ein welche du für Asianconnect88 benutzt und wir werden dir dabei helfen ein neues Passwort zu generieren.",
    'English': 'Englisch',
    'French': 'Französisch',
    'German': 'Deutsch',
    'Spanish': 'Spanisch',
    'Asian Odds': 'AsianOdds',
    'Note: Referral URL is your unique link where you can share to everyone': 'Anmerkung: Die Referral URL ist ein einmaliger Link welchen du versenden kannst',
    'Referral HTML Code': 'Referral HTML Code',
    'copyReferralCodeNote': 'Kopiere oder Downloade den HTML Code deiner Kampagne und füge ihn auf deiner Webseite ein.',
    'Download HTML': 'Download HTML',
    'Terms and Conditions': 'Allgemeine Geschäftsbedingungen',
    'and': 'und',
    'Commission Scheme': 'Kommissions Schema',
    'apply': 'anfragen',
    'Referral URL': 'Referral URL',
    'Note: Your Referral URL is a unique link which you can use to refer new members to Asianconnect.': 'Anmerkung: Deine Referral URL ist ein einmaliger Link womit du Kunden zu Asianconnect referieren kannst.',
    'Information': 'Information',
    'Get a unique tracking link for your campaign.': 'Erstelle einen einzigarten tracking Link für deine Kampagne.',
    'Website. Input your website URL.': 'Webseite. Füge die URL deiner Webseite ein.',
    'Banner type. Pick a banner type: (language/size/promo)': 'Typ des Banners, wähle einen Banner Typen aus: (Sprache/Größe/Promo)',
    'Campaign. Name your campaign.': 'Kampagne. Gib deiner Kampagne einen Namen',
    'Tracking code. Do you have a preferred tracking code? Input preferred tracking code. Click on generate.': 'Tracking code. Hast du einen bevorzugten tracking code? Gebe deinen bevorzugten tracking code ein. Klicke auf Generieren.',
    'Your Referral Code URL/s is a unique link which you can use to refer new  members to Asianconnect.': 'Dein Referral Code URL/s sind bestimmte Links welche to benutzen kannst um Kunden zu Asianconnect zu referieren.',
    'campaignNote': 'Kopiere den HTML Code deiner Kampagne und füge ihn im gewünschten Bereich deiner Webseite ein.',
    'Preview archived banner': 'Vorschau archivierter Banner',
    'Uploaded': 'Hochgeladen',
    'Drag and drop files here or': 'Drag & Drop die Datei hier oder',
    'Select file(s)': 'wähle Datei(en) aus',
    'Only .jpg, .jpeg, docx, doc, pdf and .png with maximum of 2MB is allowed.': 'Nur .jpg .jpeg docx doc pdf und .png mit einer maximalen Größe von 2MB erlaubt.',
    'file(s) selected. Click upload to proceed.': 'Datei(en) ausgewählt. Klicke auf hochladen um fortzufahren.',
    'The file is too large (MB). Allowed maximum size is 2MB.': 'Die Datei ist zu groß (MB). Die erlaubte maximale Größe ist 2MB.',
    'Only .jpeg , .jpg , .png , .pdf , .doc and .docx are allowed.': 'Nur .jpg .jpeg .png .pdf .doc und .docx sind erlaubt.',
    'Successfully uploaded!': 'Erfolgreich hochgeladen!',
    'Documents uploaded': 'Dokumente hochgeladen',
    'Delete Document': 'Lösche Dokument',
    'Are you sure you want to delete this document?': 'Bist du sicher, dass du dieses Dokument löschen willst?',
    'Cancel': 'Abbrechen',
    'Delete': 'Löschen',
    'Account Information': 'Kontoinformation',
    'Customer ID': 'Kundennummer',
    'Full name': 'Vollständiger Name',
    'Currency': 'Währung',
    'Country': 'Land',
    'Date of birth': 'Geburtstag',
    'Join date': 'Datum der Anmeldung',
    'Email Address': 'E-Mail Adresse',
    'Phone number': 'Telefonnummer',
    'Skype': 'Skype',
    'Username': 'Benutzername',
    'K.Y.C documents': 'K.Y.C Dokumente',
    'Password changed.': 'Passwort geändert.',
    'I want to request a new reset code.': 'Ich möchte einen neuen Reset code beantragen.',
    'Loading, please wait...': 'Laden bitte warten…',
    'Request new reset code?': 'Neuen Reset code beantragen??',
    'Enter your new account password below.': 'Gebe dein neues Kontopasswort ein',
    'Account password has been successfully updated!': 'Kontopasswort erfolgreich aktualisiert!',
    'Update AMS account password': 'Aktualisiere AMS Kontopasswort',
    'Current AMS password': 'Aktuelles AMS Kontopasswort',
    'New AMS Password': 'Neues AMS-Passwort',
    'Enter current password': 'Gebe aktuelles Passwort ein',
    'Enter new password': 'Gebe neues Passwort ein',
    'Confirm new password': 'Bestätige neues Passwort',
    'Update': 'Aktualisieren',
    'Are you sure you want to delete this Bank Account?': 'Bist du sicher, dass du dieses Bankkonto löschen möchtest?',
    'Add bank accounts for faster transaction.': 'Füge Bankkonten für schnellere Transaktionen hinzu.',
    'Default': 'Standard',
    'Link a new bank account': 'Neues Bankkonto hinzufügen',
    'Bank account successfully deleted.': 'Bankkonto erfolgreich gelöscht.',
    'Success': 'Erfolg',
    'Transaction password has been successfully updated!': 'Transaktionspasswort wurde erfolgreich aktualisiert!',
    'Update AMS transaction password': 'AMS Transaktionspasswort aktualisieren',
    'Current AMS transaction password': 'Aktuelles AMS Transaktionspasswort',
    'Enter current transaction password': 'Aktuelles AMS Transaktionspasswort eingeben',
    'New AMS transaction password': 'Neues AMS Transaktionspasswort',
    'Enter new transaction password': 'Neues AMS Transaktionspasswort eingeben',
    'Confirm new transaction password': 'Neues AMS Transaktionspasswort bestätigen',
    'Account username has been successfully updated!': 'Benutzername wurde erfolgreich aktualisiert!',
    'Update AMS username': 'AMS Benutzernamen aktualisieren',
    'Current AMS username': 'Aktueller AMS Benutzername',
    'New AMS username': 'Neuer AMS Benutzername',
    'Enter new username': 'Neuen Nutzernamen eingeben',
    'Confirm new username': 'Neuen Nutzernamen bestätigen',
    'Enter password': 'Passwort eingeben',
    'Security': 'Sicherheit',
    'Update your Username, Account and Transaction Password': 'Aktualisiere deinen Benutzernamen und das Transaktionspasswort',
    'Temporarily Unavailable': 'Temporär nicht verfügbar',
    'For inquiries, please contact Customer Support.': 'Bei Anfragen bitte den Kundendienst kontaktieren.',
    'Payment Option': 'Zahlungsoption',
    'Manage your payment accounts': 'Verwalte deine Zahlungskonten',
    'Open': 'Offen',
    'Pending': 'Ausstehend',
    'Resolved': 'Geklärt',
    'Closed': 'Geschlossen',
    'Forbidden!': 'Verboten!',
    'My Products': 'Meine Produkte',
    'Add Product': 'Produkt hinzufügen',
    'Reset Product Password': 'Produktpasswort zurücksetzen',
    'New': 'Neu',
    'Bank account successfully created.': 'Bankkonto erfolgreich erstellt.',
    'Link a bank account': 'Ein Bankkonto verlinken',
    'Enter Account Number': 'Kontonummer eingeben',
    'Enter Account Name': 'Kontoname eingeben',
    'Enter Citizenship': 'Staatsangehörigkeit eingeben',
    'Enter Address': 'Adresse eingeben',
    'Enter Bank Code': 'Bankleitzahl eingeben',
    'Enter Bank Name': 'Bankname eingeben',
    'Enter Bank Address': 'Adresse der Bank eingeben',
    'Save bank account': 'Bankkonto speichern',
    'Save': 'Speichern',
    'Limit Reached!': 'Limit erreicht!',
    'Go to Settings': 'Gehe zu Einstellungen',
    'Product password successfully requested.': 'Produktpasswort erfolgreich angefordert.',
    'Warning': 'Warnung',
    'Something went wrong. Please try again later.': 'Es ist etwas fehlgeschlagen. Bitte versuche es später erneut.',
    'Request Product Password': 'Produktpasswort anfragen',
    'Select one or more products to reset password': 'Wähle ein oder mehrere Produkte aus um das Passwort zurückzusetzen.',
    'View Password': 'Passwort ansehen',
    'Expires on': 'Läuft ab',
    'Expired Password': 'Abgelaufenes Passwort',
    'No Password': 'Kein Passwort',
    'Enter Transaction Password': 'Transaktionspasswort eingeben',
    'Request': 'Anfrage',
    'Product password will be available once password has been reset.': 'Produktpasswort ist verfügbar sobald das Passwort zurückgesetzt wurde.',
    'Warning!': 'Warnung!',
    'Warning! The following product/s has pending request': 'Warnung! Das folgende Produkt hat eine ausstehende Anfrage',
    'Request Product': 'Produktanfrage',
    'Please select at least one product below': 'Bitte wähle mindestens ein unten aufgeführtes Produkt aus',
    'No products available. You already have all the products Asianconnect offers.': 'Keine Produkte zur Auswahl verfügbar. Du verfügst schon über alle Produkte die Asianconnect anbietet.',
    'username': 'Benutzername',
    'SINGBET FORCED POSITION TAKING ON ASIANCONNECT': 'SINGBET FORCIERT ASIANCONNECT ZUM POSITION TAKING',
    'Profit and Loss (PnL)': 'Gewinn und Verlust (GuV/PnL)',
    'Please note that your win(profit)/loss on SINGBET is always PnL*0.40.': 'Bitte beachte, dass dein Gewinn/Verlust bei Singbet immer GuV/PnL*0.40 beträgt.',
    'So if your wager is 1000 and you win, you only win 400 EUR/GBP (1000*.040).': 'Wenn du z.B. 1000 setzt und gewinnst, gewinnst du im Endeffekt nur 400 EUR/GBP (1000*0.40).',
    'Then if you lose, you only lose 400 EUR/GBP.': 'Wenn du verlierst, dann verlierst du nur 400 EUR/GBP',
    'Deposits': 'Einzahlungen',
    'Your deposit on SINGBET is always amount/0.40. This means that if you send 1000 EUR/GBP, we will add 2500 (1000/0.40=2500) to your SINGBET credit.': 'Deine Einzahlung bei SINGBET ist immer Betrag/0.40. Das bedeutet wenn du 1000 EUR/GBP einzahlst fügen wir 2500 (1000/0.40=2500) deinem SINGBET Konto hinzu.',
    'Withdrawals': 'Auszahlungen',
    'Likewise, your withdrawal amount is /0.40. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2500 (1000/0.40) from your SINGBET credit.': 'Ebenso verhält es sich bei Auszahlungen. Betrag/0.40. Das bedeutet wenn du 1000 EUR/GBP auszahlen möchtest, dann buchen wir 2500 (1000/0.4) von deinem SINGBET Guthaben ab.',
    'In AMS Account will appear EUR/GBP money, however in your Singbet account is Singbet money.': 'In AMS Konto wird ein EUR/GBP Betrag angezeigt, allerdings ist das Guthaben in deinem SINGBET Konto sogenanntes „Singbet Guthaben“.',
    'I agree to the Terms and Conditions': 'Ich akzeptiere die allgemeinen Geschäftsbedingungen',
    'MAXBET FORCED POSITION TAKING ON ASIANCONNECT': 'MAXBET FORCIERT ASIANCONNECT ZUM POSITION TAKING',
    'Please note that your win(profit)/loss on MAXBET is always PnL*0.50.': 'Bitte beachte, dass dein Gewinn/Verlust bei MAXBET immer GuV/PnL*0.50 beträgt.',
    'So if your wager is 1000 and you win, you only win 500 EUR/GBP (1000*.050).': 'Wenn du z.B. 1000 setzt und gewinnst, gewinnst du im Endeffekt nur 500 EUR/GBP (1000*0.50).',
    'Then if you lose, you only lose 500 EUR/GBP.': 'Wenn du verlierst, dann verlierst du nur 500 EUR/GBP.',
    'Your deposit on MAXBET is always amount/0.50. This means that if you send 1000 EUR/GBP, we will add 2000 (1000/0.50=2000) to your MAXBET credit.': 'Deine Einzahlung bei MAXBET ist immer Betrag/0.50. Das bedeutet wenn du 1000 EUR/GBP einzahlst fügen wir 2000 (1000/0.50=2000) deinem MAXBET Konto hinzu.',
    'Likewise, your withdrawal amount is /0.50. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2000 (1000/0.50) from your MAXBET credit.': 'Ebenso verhält es sich bei Auszahlungen. Betrag/0.50. Das bedeutet wenn du 1000 EUR/GBP auszahlen möchtest, dann buchen wir 2000 (1000/0.5) von deinem MAXBET Guthaben ab.',
    'In AMS Account will appear EUR/GBP money, however in your Maxbet account is Maxbet money.': 'In AMS Konto wird ein EUR/GBP Betrag angezeigt, allerdings ist das Guthaben in deinem MAXBET Konto sogenanntes „Maxbet Guthaben“.',
    'SBOBET Forced Position Taking ON ASIANCONNECT': 'SBOBET FORCIERT ASIANCONNECT ZUM POSITION TAKING',
    'Please note that your win(profit)/loss on SBOBET is always PnL*0.30. So if your wager is 1000 and you win, you only win 300 EUR/GBP (1000*.30).Then if you lose, you only lose 300 EUR/GBP.': 'Bitte beachte, dass dein Gewinn/Verlust bei SBOBET immer GuV/PnL*0.30 beträgt. Wenn du z.B. 1000 setzt und gewinnst, gewinnst du im Endeffekt nur 300 EUR/GBP (1000*0.30). Wenn du verlierst, dann verlierst du nur 300 EUR/GBP',
    'Your deposit on SBOBET is always amount/0.30. This means that if you send 1000 EUR/GBP, we will add 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.': 'Deine Einzahlung bei SBOBET ist immer Betrag/0.30. Das bedeutet wenn du 1000 EUR/GBP einzahlst fügen wir 3333.33 (1000/0.30=3333.33) deinem SBOBET Konto hinzu.',
    'Likewise, your withdrawal amount is /0.30. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.': 'Ebenso verhält es sich bei Auszahlungen. Betrag/0.30. Das bedeutet wenn du 1000 EUR/GBP auszahlen möchtest, dann buchen wir 3333.33 (1000/0.33) von deinem SBOBET Guthaben ab.',
    'In AMS Account, amount will appear as EUR/GBP money, however in your SBObet account is SBObet money.': 'In AMS Konto wird ein EUR/GBP Betrag angezeigt, allerdings ist das Guthaben in deinem SBOBET Konto sogenanntes „Sbobet Guthaben“.',
    '9WICKETS FORCED POSITION TAKING ON ASIANCONNECT': '9WICKETS FORCIERT ASIANCONNECT ZUM POSITION TAKING',
    'Please note that 9wickets have 3% commission rate applied to your winnings.': 'Bitte beachte, dass 9Wickets eine Kommission in Höhe von 3% von deinen Gewinnen abführt.',
    'Please be informed as well that 9wickets is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, 9wickets has the right to close your account and forfeit your balance.': 'Wir möchten dich darüber informieren, dass 9wickets täglich eine Überprüfung von allen Wetten durchführt die auf ihrer Plattform platziert wurden. Sollten betrügerische Aktivitäten oder auffällige Wettmuster auffallen, so hat 9wickets das Recht dein Konto zu schließen und das Guthaben einzuhalten.',
    'ORBITX FORCED POSITION TAKING ON ASIANCONNECT': 'ORBITX FORCIERT ASIANCONNECT ZUM POSITION TAKING',
    'Please note that OrbitX have 3% commission rate applied to your winnings.': 'Bitte beachte, dass ORBITX eine Kommission in Höhe von 3% von deinen Gewinnen abführt.',
    'Please be informed as well that OrbitX is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, OrbitX has the right to close your account and forfeit your balance.': 'Wir möchten dich darüber informieren, dass ORBITX täglich eine Überprüfung von allen Wetten durchführt die auf ihrer Plattform platziert wurden. Sollten betrügerische Aktivitäten oder auffällige Wettmuster auffallen, so hat ORBITX das Recht dein Konto zu schließen und das Guthaben einzuhalten.',
    'SKYPE BETTING TERMS AND CONDITONS ON ASIANCONNECT': 'SKYPE BETTING ALLGEMEINE GESCHÄFTSBEDINGUNGEN BEI ASIANCONNECT',
    'You can contact us via Skype at': 'Du kannst uns über Skype kontaktieren',
    'NV for Skype betting Terms and Conditions.': 'NV für Skype betting Allgemeine Geschäftsbedingungen.',
    'Successfully added!': 'Erfolgreich hinzugefügt!',
    'The following product/s have been added. You may now request deposit into your account. You will receive your product/s username and password once we have received your deposit. Thank you.': 'Die folgenden Produkte wurden hinzugefügt. Du kannst nun eine Einzahlung anfordern um dein Konto aufzuladen. Du erhältst den Benutzernamen und das Passwort für das Konto sobald wir die Einzahlung erhalten haben. Vielen Dank.',
    'About Us': 'Über uns',
    'Contact Us': 'Kontaktiere uns',
    'Legal Disclaimer': 'Rechtlicher Hinweis',
    'Privacy Policy': 'Datenschutzrichtlinie',
    'Go To Transaction Overview': 'Gehe zur Transaktionsübersicht',
    'Notification': 'Benachrichtigung',
    'was deleted.': 'wurde gelöscht.',
    'Failed to delete': 'Löschen fehlgeschlagen',
    'file has been uploaded.': 'datei wurde hochgeladen',
    'Failed to upload': 'Hochladen fehlgeschlagen',
    'Paste an address where you want to receive BTC': 'Füge deine BTC Empfängeraddresse ein',
    'New referral': 'Neue Überweisung',
	  'has been linked.': 'wurde verknüpft.',
	  'Referral': 'Überweisung',
	  'has been unlinked.': 'wurde nicht verbunden.',
	  'Product/s': 'Produkt',
	  'has been added.': 'wurde hinzugefügt.',
	  'Transaction': 'Transaktion',
	  'has been': 'ist gewesen',
	  'Deposit': 'Einzahlung',
	  'Withdraw': 'Auszahlung',
	  'Transfer': 'Überweisung',
	  'P2P Transfer': 'P2P Überweisung',
	  'Approved': 'Genehmigt',
	  'Acknowledged': 'Anerkannt',
	  'Processed': 'Verarbeitet',
	  'Saved': 'Gerettet',
	  'Invalid Credentials!': 'Ungültige Eingabe!',
    'Email': 'E-Mail',
    'Account ID': 'Account ID',
    'Name': 'Name',
    'Request Deposit': 'Einzahlung anfordern',
		'Request Withdrawal': 'Auszahlung anfordern',
		'Upload': 'Upload',
		'W/L': 'W/L',
		'Bonus': 'Bonus',
		'Revenue Share': 'Umsatzbeteiligung',
		'Total W/L:': 'Gesamt W/L:',
		'Total Bonus:': 'Gesamtbonus:',
		'Total Revenue Share:': 'Gesamtumsatzanteil:',
		'Unlimited': 'Unbegrenzt',
		'Instant': 'Sofort',
		'My Tickets': 'Meine Tickets',
		'Product is required': 'Produkt wird benötigt',
		'Transaction password invalid': 'Transaktionspasswort_ungültig',
		'Transaction deposit has been saved': 'Transaktion Einzahlung wurde gespeichert',
		'Product has been added': 'Produkt wurde hinzugefügt',
		'Transaction withdrawal has been saved': 'Transaktion Auszahlung wurde gespeichert',
		'Transaction transfer has been saved': 'Transaktion Überweisung wurde gespeichert',
		'Transaction deposit has been declined': 'Transaktion Einzahlung wurde abgelehnt',
		'Transaction withdrawal has been declined': 'Transaktion Auszahlung wurde abgelehnt',
		'Transaction transfer has been declined': 'Transaktion Überweisung wurde abgelehnt',
		'Transaction deposit has been voided': 'Transaktion Einzahlung wurde storniert',
		'Transaction withdrawal has been voided': 'Transaktion Auszahlung wurde storniert',
		'Transaction transfer has been voided': 'Transaktion Überweisung wurde storniert',
		'Documents uploaded:': 'Dokumente hochgeladen:',
		'Warning! At least one product is required.': 'Warnung! Es ist mindestens ein Produkt erforderlich.',
		'paymentOptionsViewDetails': 'Wichtig: Nachdem du deine Einzahlung getätigt hast, fülle diesen Bereich aus. Falls dies nicht erfolgt wird deine Einzahlung ungültig. Wir benötigen diese Information um über die Transaktion in Kenntnis gesetzt zu werden und um zu überprüfen ob die Einzahlung bereits in deinem Konto vermerkt wurde.',
		'File(s) still uploading, please wait.': 'Datei (en) werden noch hochgeladen. Bitte warten Sie.',
		'DEPOSIT': 'EINZAHLUNG',
		'WITHDRAWAL': 'AUSZAHLUNG',
		'TRANSFER': 'ÜBERWEISUNG',
		'BONUS': 'BONUS',
		'PSP TRANSFER': 'PSP ÜBERWEISUNG',
		'COMMISSION': 'KOMMISSION',
		'DEBIT': 'DEBIT',
		'CREDIT': 'KREDIT',
		'REVENUE SHARE': 'UMSATZBETEILIGUNG',
    'RESET BOOKIE PASSWORD': 'RESET BOOKIE PASSWORT',
    'Ecopayz Merchant Account (EUR)': 'Ecopayz-Händlerkonto (EUR)',
  }
}


// WEBPACK FOOTER //
// ./client/app/shared/locales/locale-de.js